import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import en from "./msg_en.json";
import ja from "./msg_ja.json";

const resources = {
  ja: {
    translation: ja,
  },
  en: {
    translation: en,
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: "ja",
  interpolation: {
    escapeValue: false,
    prefix: "${",
    suffix: "}",
  },
});

export default i18n;
